<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: block" [class.fill]="true">
				<div
					class="fill"
					[style.display]="'grid'"
					[style.gridTemplateRows]="'auto 1fr auto'"
					[style.gridTemplateColumns]="'auto clamp(200px, 80%, 1200px) auto'"
					[style.gridTemplateAreas]='&apos;"header header header" "left main right" "footer footer footer"&apos;'
				>
					<div
						style="background: gainsboro; grid-area: header"
						[id]="'header'"
						data-content-area="header"
						data-defined-in="Common.MainLayout"
					>
						<div
							class="layout-block"
							style="align-items: center; width: 100%"
							[style.align-items]="'inherit'"
							[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
							[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
							[style.gap]="'1em'"
						>
							<Common-Logo
								[$formDirective]="$formDirective"
								[$disabled]="$disabled"
								[$ignoreValidations]="$ignoreValidations"
							>
							</Common-Logo>
							<a [href]="'/' | safeUrl" target="_self">
								<span
									[innerHtml]="'Link 1' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</a>
							<a [href]="'/' | safeUrl" target="_self">
								<span
									[innerHtml]="'Link 2' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</a>
							<a [href]="'/' | safeUrl" target="_self">
								<span
									[innerHtml]="'Link 3' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</a>
							<div
								class="layout-block"
								[style.flex]="'1 0 auto'"
								[style.align-items]="'inherit'"
								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.gap]="'1em'"
							></div>
							<lowgile-language-switcher
								[languageBridge]="Sys.Language"
								type="globe"
								texts="displayNames"
								style="margin-right: 1em"
							/>
						</div>
					</div>

					<div
						style="padding: 1em; overflow-y: auto; grid-area: left"
						data-content-area="left"
						data-defined-in="Common.MainLayout"
					>
						<Common-SideMenu
							[$formDirective]="$formDirective"
							[$disabled]="$disabled"
							[$ignoreValidations]="$ignoreValidations"
						>
						</Common-SideMenu>
					</div>

					<div
						style="padding: 1em; overflow-y: auto; grid-area: main"
						[id]="'main-content'"
						data-content-area="main"
						data-defined-in="Common.MainLayout"
					>
						<ng-template
							[ngTemplateOutlet]="getContentTemplate('content')"
							[ngTemplateOutletContext]="{ $scope, $formDirective, $disabled }"
						></ng-template>
					</div>

					<div
						style="background: gainsboro; padding: 0.5em; grid-area: footer"
						[id]="'footer'"
						data-content-area="footer"
						data-defined-in="Common.MainLayout"
					>
						<span
							[innerHtml]="'Footer' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
